export default __webpack_public_path__ + "static/step6-9414b4aa7c101f37329f548bbc7e44ef.svg";